<script>
import _ from 'lodash'
import {AnswerStore} from './AnswerStore'
import {FinanceConsiderStore} from './FinanceConsiderStore'

export default {

  props: {
    idquestion: Number,
    idcategory: Number,
    countwords: Boolean,
    required: Boolean,
    question: String,
    help: String,
    type: Number,
    inputtype: String,
    options: Array,
    optionsdefault: String,
    whitelist: Array,
    whitelistreason: String,
    blacklist: Array,
    blacklistreason: String,
    consider: Array,
    ServerAnswer: String,
    ServerLastModified: Number,

  },

  data() {
    return {
      answer: '',
      lastmodified: 0,
      AnswerStore,
      FinanceConsiderStore,
      considerArr: [],

    }

  },

  methods: {
    // Consider these other categories based on criteria
    // Returns an array of idcategories, but there will typically be only one element in it

    // Contains a hack! Since the financial questions are not in their own question box, we have to inform a sibling component
    // that will show the consider options in the right place. Note that we can't use provide/inject because it's a sibling and not a descendent
    // and we can't use Teleport because this component is a child of another one and teleporting into a component does not seem to work
    // We use the central store method instead
    handleConsider() {


      let out = []
      let answernumber = Number

      // We convert our answer into a number in case we need it during the comparisons
      let foo = this.answer.toString().match(/(\d.*)/g)

      if ((foo !== null) && (foo.length === 1)) {
        answernumber = parseFloat(foo[0])
      }


      this.consider.forEach((element) => {
        //If ValA is a number, then we use the float answer
        //If ValA is a string, then we use the string
        let answer

        switch (typeof(element.valA)) {
          case 'number':
            answer = answernumber
            break;
          case 'string':
            answer = this.answer
            break;
        }

        let considercat = {idcategory: element.idcategory, msg: element.msg}

        switch (element.comparator) {
          case 'between':
            if ((answer >= element.valA) && (answer <= element.valB)) {
              out.push(considercat)
            }
            break;
          case 'greater':
            if (answer > element.valA) {
              out.push(considercat)
            }
            break;
          case 'less':
            if (answer < element.valA) {
              out.push(considercat)
            }
            break;
          case 'equal':
            if (answer === element.valA) {
              out.push(considercat)
            }
            break;

        }

      })

      if (([243, 244, 245, 246].includes(this.idquestion)) && (out.length > 0)) {
        FinanceConsiderStore.doset(this.idquestion, out)
      }

      this.considerArr = out

    }


  },

  computed: {

    wordcount() {

      //Count the number of words
      let i = 0
      let foo = this.answer.toString() // We do this because answer is sometimes an integer and replace is not an integer function
      //Regex counts word chars together as one word, or a single hyphen on its own
      foo.replace(/([\w]+|^-$)/g, function () {
        i++;
      })
      return i

    },

    //Has something been entered that is in the whitelist? It is false, until we hit something good, then it is true.
    //However, if whitelist is an empty array, it always returns true
    whitelistPass() {
      if ((this.answer.length === 0) || (this.whitelist.length === 0)) {
        return true
      }

      return _.includes(this.whitelist, this.answer)

    },

    //Has something been entered that is in the blacklist. It is true (meaning - we are passing the blacklist check), until we hit something bad, then it goes false.
    //However, if blacklist is an empty array, it always returns true
    blacklistFail() {
      if ((this.answer.length === 0) || (this.blacklist.length === 0)) {
        return false
      }

      return _.includes(this.blacklist, this.answer.toLowerCase())

    },

    // If we're not required to answer the question, then we're always satisfied
    satisfied() {
      if (this.required === false) {
        return true
      }

      if ((this.answer.length > 0) && (this.whitelistPass === true) && (this.blacklistFail === false)) {
        return true
      } else {
        return false
      }

    },
  },

  watch: {
    //These watchers are used to copy computed properties into the AnswerStore

    wordcount: {
      handler(val) {
        this.AnswerStore.wordcounts[this.idquestion] = val
      },
      immediate: true
    },

    satisfied: {
      handler(val) {
        this.AnswerStore.satisfiedes[this.idquestion] = val
      },
      immediate: true
    },


  },

  created: function () {
    // These props don't change so we don't need to make them into watchers and can go straight into AnswerStore
    this.AnswerStore.requireds[this.idquestion] = this.required
    this.AnswerStore.countwords[this.idquestion] = this.countwords

    //Initially bring in answer and lastmodified from the server
    this.answer = this.ServerAnswer
    this.lastmodified = this.ServerLastModified


    //Now the answer and lastmodified has been pre-populated and correct from the server, we can start the watchers

    this.$watch('answer', (val) => {

          this.lastmodified = Date.now()
          this.AnswerStore.answers[this.idquestion] = val
          this.handleConsider()


        }, {
          //immediate: true
        }
    )


    this.$watch('lastmodified', (val) => {

      this.AnswerStore.lastmodifieds[this.idquestion] = val

    }, {
      //immediate: true
    })

    // This copies the default option into the answer if it's blank. We do this after we've started the watchers
    // so it is caught and uploaded
    if ((this.answer === '') && (this.optionsdefault !== '')) {
      this.answer = this.optionsdefault
    }


  },


}

</script>


<template>
  <div>
    <div class="question-wrap" v-if="type === 1">
      <span class="question-wordscounted" v-if="countwords">*</span>
      <span class="question-required" v-if="required">(Required)</span>
      <div class="question-question" v-html="question"></div>
      <div class="question-help" v-html="help"></div>
      <input class="form-control" :type="this.inputtype" :value="answer" @input="answer = $event.target.value.toString()">
      <div class="alert alert-danger mt-4" v-show="blacklistFail === true" v-html="blacklistreason"></div>
      <div class="alert alert-info mt-4" v-for="consider in considerArr">{{ consider.msg }}</div>
    </div>

    <div class="question-wrap" v-if="type === 2">
      <span class="question-wordscounted" v-if="countwords">*</span>
      <span class="question-required" v-if="required">(Required)</span>
      <div class="question-question" v-html="question"></div>
      <div class="question-help" v-html="help"></div>
      <textarea class="form-control" v-model="answer" rows="5"></textarea>
      <div class="alert alert-info mt-4" v-for="consider in considerArr">{{ consider.msg }}</div>
    </div>

    <div class="question-wrap" v-if="type === 3">
      <span class="question-wordscounted" v-if="countwords">*</span>
      <span class="question-required" v-if="required">(Required)</span>
      <div class="question-question" v-html="question"></div>
      <div class="question-help" v-html="help"></div>
      <select class="form-control" v-model="answer">
        <option disabled value="">Please Select...</option>
        <option v-for="option in options" v-bind:value="option">{{ option }}</option>
      </select>
      <div class="alert alert-danger mt-4" v-show="whitelistPass === false" v-html="whitelistreason"></div>
      <div class="alert alert-info mt-4" v-for="consider in considerArr">{{ consider.msg }}</div>
    </div>

    <div v-if="type === 4">
      <input class="form-control" :type="this.inputtype" v-model="answer">
    </div>

    <div class="question-wrap" v-if="type === 6">
      <span class="question-wordscounted" v-if="countwords">*</span>
      <span class="question-required" v-if="required">(Required)</span>
      <div class="question-question" v-html="question"></div>
      <div class="question-help" v-html="help"></div>
      <div class="form-check form-check-inline" v-for="option in options">
        <input type="radio" class="form-check-input" v-model="answer" :value="option" :id="idquestion + option"/>
        <label class="form-check-label" :for="idquestion + option">{{option}}</label>
      </div>
      <div class="alert alert-danger mt-4" v-show="whitelistPass === false" v-html="whitelistreason"></div>
      <div class="alert alert-info mt-4" v-for="consider in considerArr">{{ consider.msg }}</div>
    </div>

  </div>
</template>